import { Clock, Eye, User } from "lucide-react";

export const ConnectCard1 = ({
  item,
  badgeText = "Featured",
  badgeClass = "bg-orange-500/90",
  primaryCta = { label: "Read More", onClick: null },
  onArticleClick,
  imgH = 'h-56',
  objimg = 'object-cover'
}) => {
  return (
    <article
      className="
        group relative bg-white rounded-2xl overflow-hidden
        border border-gray-200 
        hover:border-orange-500
        shadow-md
        hover:shadow-[0_18px_55px_rgba(249,115,22,0.22)]
        transition-all duration-300 flex flex-col
      "
    >
      {/* IMAGE */}
      <div className={`relative ${imgH}  overflow-hidden `}>
        <img
          src={item?.small_image || item?.image 
          || item?.cover_image
          }
          alt={item?.title}
          loading="lazy"
          className={`h-full w-full ${objimg} transition-transform duration-700
            ease-out hover:scale-110`}
        />
      </div>

      {/* CONTENT */}
      {/* <div className="py-5 px-4 flex flex-col gap-2 flex-1"> */}
      <div className="py-5 px-4 flex flex-col gap-2 flex-1 min-h-[278px]">
        {/* META */}
        <span className="flex items-center gap-2">
          <User size={14} className="opacity-60" />
          <span className="font-medium text-gray-700">
            {item?.author || "THT"}
          </span>
        </span>

        <div className="flex flex-wrap items-center justify-between gap-x-2 gap-y-2 text-[13px] text-gray-500">
          <span className="flex items-center gap-2">
            <Clock size={14} className="opacity-60" />
            {new Date(item?.created_at).toLocaleDateString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
          </span>

          <span className="inline-flex items-center gap-2 px-2.5 py-1 rounded-md bg-orange-50 text-orange-700 font-semibold">
            <Eye size={14} />
            {item?.view ?? 0}
            <span className="font-normal text-orange-600">views</span>
          </span>
        </div>

        {/* TITLE */}
        <h3
          className="
           text-[16px] font-semibold text-[#9d2e43] leading-snug
            tracking-tight line-clamp-2 group-hover:text-orange-600 transition-colors
          "
        >
          {item?.title}
        </h3>

        {/* DESCRIPTION */}
        <p className="text-[14px]  leading-[1.6]  !text-[#6a6868] line-clamp-3">
          {stripHtml(item?.description || item?.meta_description || item?.quote)}
        </p>

        {/* FOOTER */}
        <div className="pt-3 flex flex-wrap items-center gap-2 justify-between mt-auto">
   <button
            onClick={() => onArticleClick?.(item)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-orange-50 text-orange-600 font-medium text-xs xl:text-sm hover:bg-orange-100 transition-colors w-auto"
          >
            Read More <span className="text-sm">→</span>
          </button>

          {item?.post_url && (
            <a
              href={item.post_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-gray-100 text-gray-700 font-medium text-xs xl:text-sm hover:bg-gray-200 transition-colors w-auto"
            >
              Visit on Site <span className="text-sm">↗</span>
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

function stripHtml(html, limit = 160) {
  if (!html) return "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const text = doc.body.textContent || "";

  return text.length > limit
    ? text.slice(0, limit).trim() + "…"
    : text.trim();
}
